<div class="w-100 text-start accordion" [appStoryblok]="_editable">
  <h3 class="title d-flex flex-row user-select-none justify-content-between w-100 align-items-center mb-0"
    (click)="toggle()">
    {{ title }}
    <img *ngIf="body" [ngClass]="{ rotate: isOpen }" width="16" height="16" class="ms-auto" src="/assets/caret.svg" />
  </h3>
  <div [@openClose]="isOpen ? 'open' : 'closed'" class="content">
    <div [storyblokRichText]="body"></div>
  </div>
</div>